import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcaseTag32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSuitcaseTag32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 5h4a2 2 0 0 1 2 2v2h-8V7a2 2 0 0 1 2-2m-4 4V7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2h3a4 4 0 0 1 4 4v11a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V13a4 4 0 0 1 4-4zm0 2H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h3v-6H9a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h1zm2 9v6h8V11h-8v3h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-3-2v-2h4v2zm13-7v15h3a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcaseTag32);
